import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import Input from 'react-toolbox/lib/input';
import { compose, withState } from 'recompose';
import { Button } from 'react-toolbox/lib/button';
import { httpPost } from '../http';
import Spinner from './Spinner';
import styles from './Form.scss';

const texts = {
  info: [
    'You can always reset your password if you cannot remember it. Fill in your email address and a reset password link will be sent to you.',
  ],
  error: ['Whoops! Something went wrong. Please try again later.'],
  success: [
    'A reset link has been sent to your email.',
    'Please follow the instructions in the email.',
  ],
  buttonBack: 'Back to login',
  buttonSubmit: 'Send reset link',
  inputPlaceholder: 'Email',
};

const propTypes = {
  email: PropTypes.string,
  state: PropTypes.shape({
    error: PropTypes.bool,
    isLoading: PropTypes.bool,
    success: PropTypes.bool,
    value: PropTypes.string,
  }),
  setState: PropTypes.func,
};

const ForgotPasswordForm = props => {
  const { state, setState, email } = props;
  const formValue = state.value !== null ? state.value : email;

  function handleSubmit(e) {
    e.preventDefault();
    setState({
      ...state,
      isLoading: true,
    });

    httpPost('/api/forgot-password', {
      email: formValue,
    })
      .then(() => {
        setState({
          isLoading: false,
          error: false,
          success: true,
        });
      })
      .catch(() => {
        setState({
          isLoading: false,
          error: true,
          success: false,
        });
      });
  }

  function handleChange(value) {
    setState({
      ...state,
      value,
    });
  }

  function renderInfo() {
    return (
      <div className={`mb-2 ${styles.body}`}>
        {texts.info.map(text => <p key={text}>{text}</p>)}
      </div>
    );
  }

  function renderError() {
    return (
      <div className={styles.alertError}>
        {texts.error.map(text => <p key={text}>{text}</p>)}
      </div>
    );
  }

  function renderSuccess() {
    return (
      <div className={styles.alertSuccess}>
        {texts.success.map(text => <p key={text}>{text}</p>)}
      </div>
    );
  }

  if (state.isLoading) return <Spinner />;

  return (
    <form
      id="forgot-password-form"
      className={styles.form}
      onSubmit={handleSubmit}
    >
      {!state.error && !state.success && renderInfo()}
      {state.error && renderError()}
      {state.success && renderSuccess()}
      {state.isLoading && <Spinner />}
      {!state.isLoading && (
        <Input
          className={styles.loginFormInput}
          id="email"
          type="email"
          name="email"
          onChange={handleChange}
          value={formValue}
          placeholder={texts.inputPlaceholder}
        />
      )}
      <div className={styles.footer}>
        <Button
          accent
          raised
          type="submit"
          className={styles.footerSubmit}
          form="forgot-password-form"
        >
          {texts.buttonSubmit}
        </Button>
        <Link to="/login" className={styles.link}>
          &#8592; {texts.buttonBack}
        </Link>
      </div>
    </form>
  );
};

ForgotPasswordForm.propTypes = propTypes;

const enhance = compose(
  withState('state', 'setState', {
    error: false,
    value: null,
    isLoading: false,
    success: false,
  })
);

export default enhance(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/client/src/components/ForgotPasswordForm.js